import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { isEmpty, map } from "lodash";
import { useCallback, useMemo, useRef } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { listTemplatesEmail } from "../../../services/campaigns";
import { CreateCampaignData } from "../../../types/campaign";
import { SUBJECT_VARIABLE } from "../../../utils/constants";
import { Autocomplete } from "../../Autocomplete";
import { PreviewHtml } from "../../PreviewHtml";

export function Email() {
  const navigate = useNavigate();
  const formik = useFormikContext<CreateCampaignData>();

  const inputSubjectRef = useRef<HTMLInputElement>(null);

  const templates = useQuery("templates", () => listTemplatesEmail("email"), {
    onSuccess: (response) => {
      formik.setFieldValue("message", response[0].link_template);
    },
  });

  const handleAddVariable = useCallback(
    (variable: string) => {
      const tempSubject = formik.values.subject || "";
      const cursor = inputSubjectRef.current.selectionStart;
      formik.setFieldValue(
        "subject",
        `${tempSubject.substring(0, cursor)}${variable}${tempSubject.substring(
          cursor
        )}`
      );
    },
    [formik]
  );

  const valueTemplates = useMemo(() => {
    return templates.data?.find(
      (template) => template.link_template === formik.values.message
    );
  }, [formik.values.message, templates.data]);

  return (
    <Stack spacing={4}>
      {!templates.isLoading ? (
        isEmpty(templates.data) ? (
          <Typography variant="button">
            Você não possui templates,{" "}
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/templates")}
            >
              clique aqui
            </Link>{" "}
            para criar um.
          </Typography>
        ) : (
          <Autocomplete
            size="small"
            label="Templates"
            loading={templates.isLoading}
            options={templates.data}
            getOptionLabel={(option) => option.nome_template}
            value={valueTemplates}
            onChange={(_, value) => {
              formik.setFieldValue("message", value?.link_template);
            }}
            error={!!formik.errors.message}
            helperText={!!formik.errors.message && formik.errors.message}
          />
        )
      ) : (
        <Skeleton height={60} variant="text" />
      )}
      <TextField
        inputRef={inputSubjectRef}
        label="Nome do remetente"
        onChange={({ target: { value } }) =>
          formik.setFieldValue("nameSender", value)
        }
        fullWidth
        size="small"
        value={formik.values.nameSender}
        error={!!formik.errors.nameSender}
        helperText={!!formik.errors.nameSender && formik.errors.nameSender}
      />
      <TextField
        inputRef={inputSubjectRef}
        label="Email do remetente"
        onChange={({ target: { value } }) =>
          formik.setFieldValue("emailSender", value)
        }
        fullWidth
        size="small"
        value={formik.values.emailSender}
        error={!!formik.errors.emailSender}
        helperText={!!formik.errors.emailSender && formik.errors.emailSender}
      />

      <TextField
        inputRef={inputSubjectRef}
        label="Assunto"
        onChange={({ target: { value } }) =>
          formik.setFieldValue("subject", value)
        }
        fullWidth
        size="small"
        value={formik.values.subject}
        error={!!formik.errors.subject}
        helperText={!!formik.errors.subject && formik.errors.subject}
      />
      <Stack justifyContent="center" direction="row" spacing={1}>
        {map(SUBJECT_VARIABLE, (variable, index) => (
          <Chip
            key={index.toString()}
            color="primary"
            size="small"
            variant="filled"
            label={variable.name}
            onClick={() => {
              handleAddVariable(variable.value);
            }}
          />
        ))}
      </Stack>
      <Typography color="primary">Preview</Typography>
      <PreviewHtml link={valueTemplates?.link_template} />
    </Stack>
  );
}
